import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-tab-mine',
  templateUrl: './tab-mine.page.html',
  styleUrls: ['./tab-mine.page.scss'],
})
export class TabMinePage implements OnInit {

  constructor(private readonly navController: NavController) { }

  ngOnInit() {
  }

  logout(){
    // window.localStorage.clear();
    // this.publicService.setCurrentUser(null);
    window.localStorage.removeItem('token');
    // this.publicService.setToken(null);
    this.navController.navigateRoot('/login');
  }
}
